import { render } from "./LineUpsField.vue?vue&type=template&id=6c22539c&scoped=true"
import script from "./LineUpsField.vue?vue&type=script&lang=js"
export * from "./LineUpsField.vue?vue&type=script&lang=js"

import "./LineUpsField.vue?vue&type=style&index=0&id=6c22539c&scoped=true&lang=css"
import "./LineUpsField.vue?vue&type=style&index=1&id=6c22539c&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-ASPN/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c22539c"]])

export default __exports__